import { ui } from "../lib/ui";

/** An on/off switch with its label: the state is the position of the knob,
 *  not a word that has to be read. */
export function Switch({
  label,
  checked,
  title,
  onChange,
}: {
  label: string;
  checked: boolean;
  title?: string;
  onChange: (checked: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      title={title}
      className="flex items-center gap-2"
      onClick={() => onChange(!checked)}
    >
      <span className={ui.label}>{label}</span>
      <span
        aria-hidden="true"
        className={`relative inline-block h-5 w-9 rounded-full transition-colors ${
          checked ? "bg-accent" : "bg-[color-mix(in_srgb,var(--muted)_35%,transparent)]"
        }`}
      >
        <span
          className={`absolute top-0.5 left-0.5 size-4 rounded-full bg-white shadow transition-transform ${
            checked ? "translate-x-4" : ""
          }`}
        />
      </span>
      <span className={`text-[13px] ${checked ? "text-text" : "text-muted"}`}>
        {checked ? "On" : "Off"}
      </span>
    </button>
  );
}
